"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLion = _interopRequireDefault(require("@rosetta/react-lion"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _variables = _interopRequireDefault(require("../constants/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RadioButtonGroupWrapper = _styled["default"].div(function (props) {
  var styles = {
    display: "block",
    position: "relative",
    height: "auto",
    width: props.width || 500
  };

  if (props.disabled) {
    styles.opacity = "0.5";
    styles.cursor = "not-allowed !important";
  }

  return styles;
});

var RadioButtonList = _styled["default"].ul({
  listStyle: "none",
  margin: 0,
  padding: 0,
  overflow: "auto"
});

var RadioButtonListItem = _styled["default"].li({
  color: _variables["default"].black,
  display: "block",
  position: "relative",
  width: "100%"
});

var RadioLabel = _styled["default"].label(function (props) {
  var styles = {
    cursor: "pointer",
    display: "block",
    fontWeight: 300,
    padding: "11px 20px 20px 50px",
    position: "relative",
    zIndex: 9,
    WebkitTransition: "all 0.25s linear",
    ":hover": {
      color: "#cccccc"
    }
  };

  if (props.labelHasSubText) {
    styles.padding = "11px 20px 0 50px";
  }

  return styles;
});

var OptionalDescriptionLabel = _styled["default"].div({
  fontSize: 12,
  marginLeft: 50,
  marginBottom: 10,
  width: 360
});

var CheckedRadio = _styled["default"].div(function (props) {
  var beforePsuedoElement = {
    display: "block",
    position: "absolute",
    content: "''",
    borderRadius: "100%",
    height: 13,
    width: 13,
    top: 2,
    left: 2,
    margin: "auto",
    transition: "background 0.25s linear",
    WebkitTransition: "background 0.25s linear"
  };

  if (props.radioInputChecked) {
    beforePsuedoElement.background = "#a8d173";
  }

  var styles = {
    display: "block",
    position: "absolute",
    border: props.radioInputChecked ? "2px solid #a8d173" : "2px solid #aaaaaa",
    borderRadius: "100%",
    height: 17,
    width: 17,
    top: 10,
    left: 10,
    zIndex: "5",
    transition: "border 0.25s linear",
    WebkitTransition: "border 0.25s linear",
    "&::before": beforePsuedoElement
  };

  if (props.hoveringOnListItem) {
    styles.border = "2px solid #cccccc";
  }

  return styles;
});

var HiddenRadioInput = _styled["default"].input({
  position: "absolute",
  visibility: "hidden"
}); // For details about what is really going on here, see this article:
// https://www.sitepoint.com/replacing-radio-buttons-without-replacing-radio-buttons/


var ModalRadioButtonGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(ModalRadioButtonGroup, _PureComponent);

  var _super = _createSuper(ModalRadioButtonGroup);

  function ModalRadioButtonGroup() {
    var _this;

    _classCallCheck(this, ModalRadioButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isHovered: {}
    });

    _defineProperty(_assertThisInitialized(_this), "onHoverListItem", function (listItemIndex) {
      return _this.setState({
        isHovered: _objectSpread(_objectSpread({}, _this.state.isHovered), {}, _defineProperty({}, listItemIndex, true))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onHoverListItemOff", function (listItemIndex) {
      return _this.setState({
        isHovered: _objectSpread(_objectSpread({}, _this.state.isHovered), {}, _defineProperty({}, listItemIndex, false))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function (key, text) {
      if (key) {
        return /*#__PURE__*/_react["default"].createElement(_reactLion["default"].span, {
          lionkey: key
        });
      } else if (text) {
        return /*#__PURE__*/_react["default"].createElement("span", null, text);
      } else {
        return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "radioInputIsChecked", function (option) {
      return option.value === _this.props.value;
    });

    return _this;
  }

  _createClass(ModalRadioButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(RadioButtonGroupWrapper, {
        disabled: this.props.disabled,
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement(RadioButtonList, null, this.props.options.map(function (option, listItemIndex) {
        return /*#__PURE__*/_react["default"].createElement(RadioButtonListItem, {
          "data-qa": option.dataQa,
          key: option.dataKey + "_" + option.value,
          onMouseOver: function onMouseOver() {
            return _this2.onHoverListItem(listItemIndex);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.onHoverListItemOff(listItemIndex);
          },
          onMouseOut: function onMouseOut() {
            return _this2.onHoverListItemOff(listItemIndex);
          }
        }, /*#__PURE__*/_react["default"].createElement(HiddenRadioInput, {
          type: "radio",
          id: option.value,
          name: _this2.props.dataKey,
          checked: _this2.radioInputIsChecked(option),
          value: option.value,
          onChange: _this2.props.onChange
        }), /*#__PURE__*/_react["default"].createElement(RadioLabel, {
          labelHasSubText: option.labelSubText,
          htmlFor: option.value,
          "data-qa": "".concat(option.labelText)
        }, _this2.renderLabel(option.labelKey, option.labelText)), option.labelSubText && /*#__PURE__*/_react["default"].createElement(OptionalDescriptionLabel, null, option.labelSubText), /*#__PURE__*/_react["default"].createElement(CheckedRadio, {
          hoveringOnListItem: _this2.state.isHovered[listItemIndex],
          radioInputChecked: _this2.radioInputIsChecked(option)
        }, /*#__PURE__*/_react["default"].createElement("div", null)));
      })));
    }
  }]);

  return ModalRadioButtonGroup;
}(_react.PureComponent);

ModalRadioButtonGroup.propTypes = {
  dataKey: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    labelKey: _propTypes["default"].string,
    labelText: _propTypes["default"].string,
    labelSubText: _propTypes["default"].string,
    checked: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    dataQa: _propTypes["default"].string
  })).isRequired
};
var _default = ModalRadioButtonGroup;
exports["default"] = _default;